export type DeferredWork = () => void

export class WorkQueue {
  private workQueue: Array<DeferredWork> = []

  clear() {
    this.workQueue = []
  }

  queueWork(work: DeferredWork) {
    this.workQueue.push(work)
  }

  completePendingWork() {
    while (this.workQueue.length > 0) {
      const pendingWork = this.workQueue.shift()
      if (pendingWork) {
        pendingWork()
      }
    }
  }
}
